export const sortByState = fields => {
  return [...fields].sort((a, b) => {
    return a.estado?.label?.localeCompare(b.estado?.label);
  });
};

export const compareSortValues = (a, b) => {
  if (a == null) return 1;
  if (b == null) return -1;
  const numA = Number(a);
  const numB = Number(b);
  if (!Number.isNaN(numA) && !Number.isNaN(numB)) return numA - numB;
  return String(a).localeCompare(String(b));
};
